import { CreateOrderRequest, OrderLine } from '@models/order';

const orderWithTotalAmount = (originalRequest: CreateOrderRequest): CreateOrderRequest => {
    const request = structuredClone(originalRequest);
    const orderLines = [...request.orderLines];
    const newOrderLines: OrderLine[] = orderLines.map((line) => {
        const {
            itemPrice, quantity, personalOptions, defaultOptions,
        } = line;
        const options = [...personalOptions, ...defaultOptions]
            .map((optionGroup) => optionGroup.options)
            .flat();

        // 실제 요청에 포함하기 위한 옵션
        const newOptions = options.map((option) => {
            const optionTotalAmount = Math.max(option.optionPrice * option.quantity, 0);
            return { ...structuredClone(option), totalAmount: optionTotalAmount };
        });
        // 계산하기 위한 옵션
        const newOptionsForTotal = options.map((option) => {
            const optionTotalAmount = option.optionPrice * option.quantity;
            return { ...option, totalAmount: optionTotalAmount };
        });
        const optionAmount = newOptionsForTotal
            .map((option) => option.totalAmount)
            .reduce((acc, cur) => acc + cur, 0);
        const totalAmount = Math.max((itemPrice + optionAmount) * quantity, 0);
        return { ...line, totalAmount, options: newOptions };
    });

    const totalAmount = newOrderLines
        .filter(((item) => item.status === 'ON_SALE'))
        .map((item) => item.totalAmount)
        .reduce((acc, cur) => acc + cur, 0);

    const totalDiscount = request.discounts?.map((d) => d.discountAmount)
        .reduce((acc, cur) => acc + cur, 0) || 0;

    const totalCouponDiscount = request.discounts
        ?.filter((d) => !!d.couponId)
        .map((d) => d.discountAmount)
        .reduce((acc, cur) => acc + cur, 0) || 0;
    return {
        ...request,
        orderLines: newOrderLines,
        totalAmount,
        paymentAmount: totalAmount - totalDiscount,
        totalDiscount,
        totalCouponDiscount,
    };
};

export default orderWithTotalAmount;
